import styles from './index.module.scss';
import { RECEIPT_TYPES } from '@autopass-web/domain';
import { Button, Card } from '@autopass-web/mochi-component';
import { generateBarCode } from '../../utils/generate-scan-code';
import { analytics, storage } from '../../app-loader';
import useAppStore from '../../app-store';
import useStore from './store';
import { barcodeScanReceipt, getReceiptData } from './barcode-payment';
import SVG from 'react-inlinesvg';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const ScanReceiptCard = () => {
  const store = useStore();
  const appStore = useAppStore();
  const receiptData = getReceiptData();

  if (barcodeScanReceipt.indexOf(receiptData.type) === -1) return <></>;
  if (receiptData.type === RECEIPT_TYPES.DONATE && !store.donateData)
    return <></>;

  let codeImageUrl, codeText;

  if (receiptData.type === 'donate') {
    codeImageUrl = generateBarCode(store.donateData.love_code);
    codeText = `${store.donateData.love_code} ${store.donateData.name}`;
  } else {
    codeImageUrl = generateBarCode(receiptData.value, {
      format:
        receiptData.type === 'carrier_mobile_barcode' ? 'CODE39' : 'CODE128',
    });
    codeText = receiptData.value;
  }

  const receiptCardClass = cx({
    'receipt-card': true,
    hide: store.receiptBarcodeHide,
  });

  return (
    <Card className={receiptCardClass}>
      <div
        className={styles.title}
        onClick={() => {
          store.toggleReceiptBarcodeHide();
          analytics.barcode_payment_receipt_toggle_onClick(
            !store.receiptBarcodeHide,
          );
          storage.saveBarcodePaymentReceiptCodeHiddenState(
            !store.receiptBarcodeHide,
          );
        }}
      >
        <div className={styles.name}>
          {receiptData.name}
          <div className={styles.arrow}>
            <SVG src="/assets/chevron-down.svg" />
          </div>
        </div>
        <Button
          type="text"
          onClick={(e) => {
            e.stopPropagation();
            analytics.barcode_payment_receipt_onClick();
            appStore.globalAction.setRedirectLink('/barcode-payment');
            appStore.globalAction.push('/receipt-setting');
          }}
          style={{ fontSize: 13 }}
        >
          更改
        </Button>
      </div>
      <div className={styles.content}>
        <div className={styles.barcode}>
          <img src={codeImageUrl} />
          <span>{codeText}</span>
        </div>
      </div>
    </Card>
  );
};

export default ScanReceiptCard;
